var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"d-flex justify-center align-center bloom-inventory-slot bg-tile-default rounded"},_vm.$listeners),[(_vm.inventory)?_c('bloom-flower',{attrs:{"item":_vm.inventory}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }